import _ from 'lodash';

// The header and the side menu both ride along on every authenticated page, so both report
// the page the chat was opened from rather than themselves. Web_/Mob_ prefixes are stripped
// so a page's webview and desktop variants report one initiator.
export default function pageInitiator(routeName) {
  const name = (routeName || '').replace(/^(Web_|Mob_)/, '');
  if (!name) {
    return 'header';
  }
  // snakeCase splits letter-digit boundaries ("SuperDiscountV2" -> "super_discount_v_2").
  return `header_${_.snakeCase(name).replace(/_v_(\d)/g, '_v$1')}`;
}
